import React, { useEffect, useState } from "react";
import { getFileCategory } from "API/swesum";
import { useNavigate } from "react-router-dom";
import Typography from "@mui/material/Typography";
import Paper from "Components/UI/Paper";
import Grid from "@mui/material/Grid";
import Button from "@mui/material/Button";
import Box from "@mui/material/Box";
import InvoiceForm from "../../../Components/Invoice/InvoiceForm";
import { useClients } from "Context/Clients";
import { useEndCustomers } from "Context/EndCustomers";
import { CURRENCYCODE } from "utils/options/CURRENCYCODE";
import { DEFAULT_SERVICE } from "utils/options/DEFAULT_SERVICE";
import { BOOLVALUE } from "utils/options/BOOLVALUE";
import { useInvoices } from "Context/Invoices";
import { usePopupNotificationContext } from "Context/NotificationPopup";

const initialState = {
  ClientId: null,
  ClientCreditFee: "",
  ClientServiceFee: "",
  ClientDirectPayment: "",
  //Collection: invoice.Collection,
  CreateTime: "",
  CurrencyCode: "SEK",
  EndCustomerId: null,
  DueDate: null,
  ExternalInvoiceNo: "",
  ExternalReference: "",
  FileId: "",
  InvoiceId: "",
  OriginalDeadlineDate: "",
  OriginalFfdDate: "",
  Pm1WaitCreateDate: "",
  OurReference: "",
  ParseMessage: "",
  ParseStatus: "",
  //Pm1DeadlineDate: invoice.Pm1DeadlineDate,
  Pm1Fee: "",
  Pm1FfdDate: "",
  //Pm1Interest: invoice.Pm1Interest,
  Pm2WaitCreateDate: null,
  Pm2Fee: "",
  CollectionWaitCreateDate: "",
  Pm2FfdDate: "",
  //Pm2Interest: invoice.Pm2Interest,
  Price: 0,
  Regress: -1,
  Service: "purchase",
  SystemStatus: "",
  Text: "",
  OCR: null,
  InvoiceReference: "",
  EndCustomerNumber: "",
  Type: "Invoice",
};

export function CreateInvoice() {
  const { createInvoice, loading } = useInvoices();
  const [formData, setFormData] = useState(initialState);
  const { endCustomers, fetchEndCustomers } = useEndCustomers();
  const { clients, fetchClients, hasFetchedAll } = useClients();
  const [files, setFiles] = useState([]);

  const { openError } = usePopupNotificationContext();

  useEffect(() => {
    const asyncFetchFiles = async () => {
      const tmpFiles = await getFileCategory("FAKTURABUNT");
      setFiles(tmpFiles);
    };
    asyncFetchFiles();
    if (!hasFetchedAll) {
      fetchClients();
    }
    fetchEndCustomers();
  }, []);

  const navigate = useNavigate();

  const handleInputChange = (field, newVal) => {
    setFormData({ ...formData, [field]: newVal });
  };

  const handleOnCreate = async () => {
    const errors = [];

    if (!formData.EndCustomerId) {
      errors.push("Slutkund måste vara ifyllt");
    }
    if (errors.length > 0) {
      const errorMessage = errors.join("\n");
      openError(errorMessage);
      return;
    }
    const res = await createInvoice(formData);
    if (res.status === 201) {
      navigate(`/invoices/${res.data.Id}`);
    } else {
      openError("Ett fel uppstod när fakturan skapades.");
    }
  };

  return (
    <>
      <Box component="main" sx={{ flexGrow: 1, overflow: "auto" }}>
        <Box sx={{ flexGrow: 1, pt: 8, pb: 3, pl: 3, pr: 3 }}>
          <Grid
            container
            rowSpacing={1}
            columnSpacing={{ xs: 1, sm: 2, md: 3 }}
          >
            <Grid item xs={12} md={12}>
              <Paper>
                <Typography
                  sx={{ marginBottom: "1.0rem" }}
                  variant="h5"
                  align="left"
                >
                  Skapa Faktura
                </Typography>
                <InvoiceForm
                  formData={formData}
                  FORM_MODE={"CREATE"}
                  handleInputChange={handleInputChange}
                  clients={clients}
                  endcustomers={endCustomers}
                  currencyCodes={CURRENCYCODE}
                  services={DEFAULT_SERVICE}
                  boolOptions={BOOLVALUE}
                  files={files}
                />
                <Grid
                  item
                  xs={12}
                  sx={{
                    display: "flex",
                    justifyContent: "flex-end",
                    mt: 4,
                  }}
                >
                  <Button onClick={() => navigate(-1)}>Stäng</Button>
                  <Button
                    onClick={() => handleOnCreate()}
                    variant="contained"
                    sx={{ ml: 3 }}
                  >
                    Spara
                  </Button>
                </Grid>
              </Paper>

              {loading && <Typography>{"Laddar"}</Typography>}
            </Grid>
          </Grid>
        </Box>
      </Box>
    </>
  );
}
